import React from "react";
import Header from "../component/Header";
import { Outlet } from "react-router-dom";

export default function Setting() {
  const navbarMenu = [
    { name: "Category", pageNavigate: "/setting/categoryView" },
    { name: "Profile", pageNavigate: "/setting/profile" },
    { name: "Branch", pageNavigate: "/setting/branchView" },
  ];
  return (
    <>
      <div className="screen_mainContainer">
        <Header navbarMenu={navbarMenu} />
        <Outlet />
      </div>
    </>
  );
}
